// Les dates metier sont des instants : les bornes de filtre partent en ISO suffixe « Z ».
export function ToInstantString(date: Date): string {
  return date.toISOString();
}

/** Debut de la journee LOCALE du lecteur, en instant ISO. */
export function DebutDeJournee(date: Date): string {
  const debut = new Date(date);
  debut.setHours(0, 0, 0, 0);
  return debut.toISOString();
}

/** Fin de la journee LOCALE du lecteur, en instant ISO. */
export function FinDeJournee(date: Date): string {
  const fin = new Date(date);
  fin.setHours(23, 59, 59, 999);
  return fin.toISOString();
}

// Decalage de `iana` par rapport a UTC, en minutes ; comparer ce que les fuseaux font, pas leur nom.
export function decalageMinutes(iana: string, instant: Date): number | null {
  try {
    const parties = new Intl.DateTimeFormat('en-US', {
      timeZone: iana,
      hour12: false,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    }).formatToParts(instant);
    const lire = (type: string) => +(parties.find((p) => p.type === type)?.value ?? '0');
    const commeUtc = Date.UTC(
      lire('year'), lire('month') - 1, lire('day'),
      lire('hour'), lire('minute'), lire('second'),
    );
    return Math.round((commeUtc - instant.getTime()) / 60000);
  } catch {
    return null;
  }
}
